(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}(function () { 'use strict';

    var version="0.3.0-SNAPSHOT";

    var setHelperNpm = function () {
        if (typeof window.farmnetNpm === 'undefined')
            window.farmnetNpm = {};
        window.farmnetNpm.helper = { version: version };
    };
    /**
     * Helper to capitalize the first letter of a string.
     *
     * @param string String to capitalize the first letter.
     * @returns string String with capitalized first letter.
     */
    var capitalizeFirstLetter = function (text) {
        // TODO:
        // [] Check for string
        // [] Check for typeof
        return text.charAt(0).toUpperCase() + text.slice(1);
    };
    /**
     * Helper to extract the first occurence of a text between
     * single quotes in a string. Common use case is to extract keys from
     * AngularJS expressions with piped filters. E.g: `{{'fe.manage.isoimport'|
     * translate}}`
     *
     * @param string String to extract first word between quotes.
     * @returns string String between quotes.
     */
    var extractFirstText = function (text) {
        // TODO:
        // [] Make it usable with double quotes
        if (typeof text === 'string') {
            var matches = text.match(/'(.*?)'/);
            return matches ? matches[1] : text;
        }
        else {
            console.warn("[helper.ts] extractFirstText: '" + text + "' is a '" + typeof text + "' and it should be a 'string'");
        }
        return '';
    };
    /**
     * Helper to add slashes to the start and end of a string. Useful e.g. to
     * standardize paths.
     *
     * @param string String to add slashes.
     * @returns string String with slashes.
     */
    var addSlashes = function (path) {
        // TODO:
        // [] Make an one liner from this
        // https://stackoverflow.com/questions/2195568/how-do-i-add-slashes-to-a-string-in-javascript
        // https://stackoverflow.com/questions/11531363/javascript-jquery-add-trailing-slash-to-url-if-not-present
        var slash = '/';
        var slashifiedStr = undefined;
        // cases
        var hasNoFirstSlash = !path.startsWith(slash) && path.endsWith(slash);
        var hasNoLastSlash = path.startsWith(slash) && !path.endsWith(slash);
        var hasNoSlash = !path.startsWith(slash) && !path.endsWith(slash);
        switch (true) {
            case hasNoFirstSlash:
                slashifiedStr = slash + path;
                break;
            case hasNoLastSlash:
                slashifiedStr = path + slash;
                break;
            case hasNoSlash:
                slashifiedStr = slash + path + slash;
                break;
            default:
                slashifiedStr = path;
                break;
        }
        return slashifiedStr;
    };
    /**
     * Helper to generate a random integer between specified values.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random | MDN web docs}
     * @param min - Minimum inclusive number.
     * @param max - Maximun exclusive number.
     * @returns Random number.
     */
    var getRandomInt = function (min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) +
            min; // the maximum is exclusive and the minimum is inclusive
    };
    var hasUserRight = function (right) {
        if (typeof right === 'string') {
            return app.credentials.rights.includes(right);
        }
        else {
            console.warn("[helper.ts] hasUserRight: '" + right + "' is a '" + typeof right + "' and it should be a 'string'");
        }
        return false;
    };
    /**
     * Get the keys from an object that match a determined regex pattern.
     *
     * @param object Object to be filtered on.
     * @param filter Regex pattern to filter on.
     * @returns array Filled with the keys that match the pattern.
     */
    var getFilteredKeys = function (object, filter) {
        var keys = [];
        var key = undefined;
        for (key in object) {
            if (object.hasOwnProperty(key) && filter.test(key)) {
                keys.push(key);
            }
        }
        return keys;
    };
    /**
     *
     *
     * @param object object Object to be checked on.
     * @param keyPattern regex
     */
    // const getFilteredKeys2 = (object: object, keyPattern: RegExp) => {
    //   return Object.keys(object).filter(key => keyPattern.test(key));
    // };
    var helper_esm = {
        setHelperNpm: setHelperNpm,
        capitalizeFirstLetter: capitalizeFirstLetter,
        extractFirstText: extractFirstText,
        addSlashes: addSlashes,
        getRandomInt: getRandomInt,
        hasUserRight: hasUserRight,
        getFilteredKeys: getFilteredKeys,
    };
    var helper_esm_4 = helper_esm.addSlashes;

    var version$1="0.7.0-SNAPSHOT";

    /*!
    * Tag Manager - Google Tag Manager implementation for 365FarmNet
    * @see {@link http://trakkguide.com/ TrakkGuide}
    * @module @farmnet/tag-manager
    * @license Copyright (c) 2018 365FarmNet GmbH, all rights reserved.
    */

    /**
     * Set global `@farmnet/tag-manager` property.
     *
     * @property {string} version - `@farmnet/tag-manager` version.
     * @property {string} location - User location.
     */
    var setTagManagerNpm = function () {
      if (typeof window.farmnetNpm === 'undefined') { window.farmnetNpm = {}; }

      window.farmnetNpm.tagManager = {
        version: version$1,
        location: undefined
      };
    };

    /**
     * Share the current user navigation location state between `@farmnet/tag-manager` consumers.
     *
     * @property {function} get - Init `userLocation`.
     * @property {function} get - Get location.
     * @property {function} set - Set location.
     */
    var userLocation = {
      init: setTagManagerNpm(),
      /**
       * Get the current user location.
       *
       * @returns {string} - The location.
       */
      get: function () { return window.farmnetNpm.tagManager.location; },
      /**
       * Set the current user location.
       *
       * @param {string} - Current navigation location.
       */
      set: function (currentLocation) {
        window.farmnetNpm.tagManager.location = currentLocation;
      }
    };

    /**
     * Sets hashed userId to be used within tracking.
     *
     * @param {string} userIdHash
     */
    var setUserId = function (userIdHash) {
      var event = {
        event: 'Page Meta',
        uiUserId: userIdHash
      };

      window.dataLayer.push(event);
    };

    /**
     * Sets the metadata for all Google Tag Manager `dataLayer.push`es.
     *
     * @param {object} metadata - Google Tag Manager metadata.
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Page Meta',
        'language': 'de', // on all sites
        'country': 'de', // on all sites
        'internalTraffic': 'false', // on all sites
        'uiLoggedIn': 'true', // only during log in
        'environment': 'testing', // on all sites
        'pageType': 'home', // on all sites
        'breakPoint': 'mid', // on all sites
        'uiUserId': '1039967', // on every page the user is logged in - hashed!
        'uiFarmSize': '110', // only during login
        'uiFarmType': 'crop', // only during login
        'uiCompanyId': '10098', // only during login - hashed!
        'uiPostalCode': '22303', // only during login
        'uiNewsletterSubscriber': 'true', // only during login and account registration
        'uiCustomerType': 'active', // only during login
        'uiEmployees': '4' // only during login
      });
      */
    var setMetadata = function (metadata) {
      console.warn("[tag-manager] This service is **deprecated** (22.02.2019) and will be removed on: 22.04.2019. Please start using '@farmnet/tag-manager/trackPageMeta' today!");
      window.dataLayer.push(metadata);
    };
    var trackPageMeta = function (pageMeta) {
      pageMeta['event'] = 'Page Meta';
      window.dataLayer.push(pageMeta);
    };

    /**
     * Logs general event with an event category (Videos, Music, Games, ...), an event action
     * (Play, Pause, Duration, Add Playlist, Downloaded, Clicked, ...), and an optional
     * event label and optional numeric value.
     *
     * @see {@link https://wiki.farmnet.intra/display/DEV/Feature+Tracking | Feature Tracking Guide}
     *
     * @param {string} category
     * @param {string} action
     * @param {string} [label]
     * @param {number} [value]
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event' : 'uaevent',
        'eventCategory': 'Navigation',
        'eventAction': 'Top_L3',
        'eventLabel': 'Product::Components::Crop Management'
      });
      */
    var trackEvent = function (category, action, label, value) {
      var event = {
        event: 'uaevent',
        eventCategory: category,
        eventAction: action
      };

      if (!category || !action) {
        console.error('[tag-manager] trackEvent() ' +
          'must be called with a category and an action');
      }

      if (label !== undefined) {
        event.eventLabel = label;
      }

      if (value !== undefined) {
        event.eventValue = value;
      }

      window.dataLayer.push(event);
    };

    /**
     * Track portal interaction event.
     *
     * @param {string} action
     * @param {string} label
     * @param {any} value
     *
     * @see {@link http://trakkguide.com/guide/365farmnet-ua-gtm-en/implementation-product-tracking#product-tracking-events/ Implementation Product Tracking}
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'portalEvent',
        'eventCategory': 'Product Interactions',
        'eventAction': 'Booking', // The tile/product name
        'eventLabel': 'BookingList::Booking::Click'
      });
      */
    var trackProductInteractionEvent = function (action, label, value) {
      var event = {
        event: 'portalEvent',
        eventCategory: 'Product Interactions',
        eventAction: action
      };

      if (!action) {
        console.error('[tag-manager] trackProductInteractionEvent() ' +
          'must be called with an action');
      }

      if (label !== undefined) {
        event.eventLabel = label;
      }

      if (value !== undefined) {
        event.eventValue = value;
      }

      window.dataLayer.push(event);
    };

    /**
     * Track portal popup interaction event.
     *
     * @param {string} action
     * @param {string} label
     * @param {number|null} opened
     * @param {number} visibility
     *
     * @see {@link http://trakkguide.com/guide/365farmnet-ua-gtm-en/implementation-product-tracking#product-tracking-events/ Implementation Product Tracking}
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'portalEvent',
        'eventCategory': 'Product Interactions',
        'eventAction': '{{Pop Up Name}}', // e.g. Nutrient needs assessment
        'eventLabel': 'Displayed',
        'popupOpened': 1
      });

      dataLayer.push({
        'event':  'portalEvent',
        'eventCategory': 'Product Pop Ups',
        'eventAction': '{{Pop Up Name}}', // e.g. Nutrient needs assessment
        'eventLabel': '{{Interaction}}', // e.g. Hide, Close, Cancel
        'popupVisibility': 2340 // Integer - floating. Time in milliseconds between displayed and interaction
      });
      */
    var trackProductPopupEvent = function (action, label, opened, visibility) {
      var event = {
        event: 'portalEvent',
        eventCategory: 'Product Pop Ups',
        eventAction: action
      };

      if (!action) {
        console.error('[tag-manager] trackProductPopupEvent() ' +
          'must be called with an action');
      }

      if (label !== undefined) {
        event.eventLabel = label;
      }

      if (opened !== undefined && opened !== null) {
        event.popupOpened = opened;
      }

      if (visibility !== undefined) {
        event.popupVisibility = visibility;
      }

      window.dataLayer.push(event);
    };

    /**
     * Track virtual pagepaths.
     *
     * @param {string} title
     * @param {string} virtPath
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'virtPath',
        'pageTitle': 'Components',
        'pagePath': '/components/my-components'
      });
      */
    var trackVirtualPath = function (title, virtPath, isMonolithPath) {
      if ( isMonolithPath === void 0 ) isMonolithPath = true;

      var fnPathName = isMonolithPath ? '/365FarmNet/dist/index.html#' : '';
      var event = {
        event: 'virtPath',
        pageTitle: title,
        pagePath: fnPathName + helper_esm_4(virtPath)
      };

      window.dataLayer.push(event);
    };

    /**
     * Track promotion impression.
     *
     * @param {array} promotions
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'EECpromotionImpression',
        'ecommerce': {
          'promoView': {
            'promotions': [
            {
              'name': 'DLG Feldtage',
              'creative': 'skyscraper_v1',
              'position': 1
            },
            // add further promotion impressions
            ]
          }
        }
      });
      */
    var trackPromotionImpression = function (promotions) {
      var event = {
        event: 'EECpromotionImpression',
        ecommerce: {
          promoView: {
            promotions: promotions
          }
        }
      };

      window.dataLayer.push(event);
    };

    /**
     * Track promotion click. Callback is optional.
     *
     * @param {array} promotions
     * @param {function} [callback]
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'EECpromotionClick',
        'ecommerce': {
          'promoClick': {
            'promotions': [{
              'name': 'DLG Feldtage',
              'creative': 'skyscraper_v1',
              'position': 1
            }]
          }
        }
      });
      */
    var trackPromotionClick = function (promotions, callback) {
      var event = {
        event: 'EECpromotionClick',
        ecommerce: {
          promoClick: {
            promotions: promotions
          }
        },
        eventCallback: callback
      };

      window.dataLayer.push(event);
    };

    /**
     * Track product list impression.
     *
     * @param {string} currency
     * @param {array} impressions
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'EECproductImpression',
        'ecommerce': {
          'currencyCode': 'EUR',
          'impressions': [{
            'name': 'Stock basic',
            'price': '0.60', // price without tax
            'brand': '365FarmNet',
            'category': 'Plant',
            'list': 'Crop management',
            'position': 1
            },
            // add further products
          ]
        }
      });
      */
    var trackProductImpression = function (currency, impressions) {
      var event = {
        event: 'EECproductImpression',
        ecommerce: {
          currencyCode: currency,
          impressions: impressions
        }
      };

      window.dataLayer.push(event);
    };

    /**
     * Track product click in product list.
     *
     * @param {string} currency
     * @param {string} list
     * @param {array} product
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'EECproductClick',
        'ecommerce': {
          'currencyCode': 'EUR',
          'click': {
            'actionField': {'list': 'Name of product list e.g. breadcrumbs'},
            'products': [{
              'name': 'Stock basic',
              'price': '0.60', // price without tax
              'brand': '365FarmNet',
              'category': 'Plant',
              'position': 1
            }]
          }
        }
      });
      */
    var trackProductClick = function (currency, list, products) {
      var event = {
        event: 'EECproductClick',
        ecommerce: {
          currencyCode: currency,
          click: {
            actionField: { list: list },
            products: products
          }
        }
      };

      window.dataLayer.push(event);
    };

    /**
     * Track product detail page view.
     *
     * @param {string} list
     * @param {array} products
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'EECproductDetailView',
        'ecommerce': {
          'currencyCode': 'EUR',
          'detail': {
            'products': [{
              'name': 'AMAZONE fertiliser service',
              'id': '', // Component-id if available
              'price': '0.50', // price without tax
              'brand': 'AMAZONE',
              'category': 'Machine settings'
            }]
          }
        }
      });
      */
    var trackProductDetailView = function (currency, products) {
      var event = {
        event: 'EECproductDetailView',
        ecommerce: {
          currencyCode: currency,
          detail: {
            products: products
          }
        }
      };

      window.dataLayer.push(event);
    };

    /**
     * Track product booking.
     *
     * @param {object} action
     * @param {array} products
     *
     * @example
     window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'EECaddToCart',
        'ecommerce': {
          'currencyCode': 'EUR',
          'add': {
            'products': [{
              'name': 'AMAZONE fertiliser service',
              'id': '', // Component-id if available
              'price': '0.50', // Component price without tax
              'brand': 'AMAZONE',
              'category': 'Machine settings',
              'quantity': 1
            }]
          }
        }
      });
    */
    // TODO: [] Do we really need product booking?
    var trackAddToCart = function (currency, products) {
      var event = {
        event: 'EECaddToCart',
        ecommerce: {
          currencyCode: currency,
          add: {
            products: products
          }
        }
      };

      window.dataLayer.push(event);
    };

    /**
     * Track product purchase.
     *
     * @param {object} action
     * @param {array} products
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'EECpurchase',
        'ecommerce': {
          'currencyCode': 'EUR',
          'purchase': {
            'actionField': {
              'id': '', // Transaction id
              'revenue': '0.50', // Total transaction value (includes fees for payment services - without tax)
              'tax': '', // Tax for revenues if available
              'coupon': 'H4RVEST' // Transaction Promotion Code
            },
            'products': [{
              'name': 'AMAZONE fertiliser service',
              'price': '0.50', // Price without tax / single price
              'brand': 'AMAZONE',
              'category': 'Machine settings',
              'quantity': 1,
              'coupon': 'H4RVEST' // Product Promotion Code
            }]
          }
        },
      });
      */
    var trackPurchase = function (currency, action, products) {
      var event = {
        event: 'EECpurchase',
        ecommerce: {
          currencyCode: currency,
          purchase: {
            actionField: action,
            products: products
          }
        }
      };

      window.dataLayer.push(event);
    };

    /**
     * Track product checkout.
     *
     * @param {string} currency
     * @param {number} step
     * @param {string} option
     * @param {array} products
     *
     * @example
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'EECcheckout',
        'ecommerce': {
          'currencyCode': '{currency}',
          'checkout': {
            'actionField': {'step': 2, 'option': 'Advance Payment'},
            'products': [{
              'name': '{Component Name}',
              'price': '{Component Price without tax - e.g. 0.50}',
              'brand': '{Brand}',
              'category': '{Component Category}',
              'quantity': '{Component Quantity}'
            }]
          }
        }
      });
      */
    // TODO: [] Make option configurable
    var trackCheckout = function (currency, step, option, products) {
      var event = {
        event: 'EECcheckout',
        ecommerce: {
          currencyCode: currency,
          checkout: {
            actionField: { step: step, option: option },
            products: products
          }
        }
      };

      window.dataLayer.push(event);
    };

    /**
     * Track product checkout option.
     *
     * @param {number} step
     * @param {string} checkoutOption
     *
     * @example
      <script>
      function onCheckoutOption(step, checkoutOption) {
        dataLayer.push({
          'event': 'EECcheckoutOption',
          'ecommerce': {
            'checkout_option': {
              'actionField': {'step': step, 'option': checkoutOption}
            }
          }
        });
      }
      onCheckoutOption(2, 'credit cart')
      </script>
      */
    var trackCheckoutOption = function (step, checkoutOption) {
      var event = {
        event: 'EECcheckoutOption',
        ecommerce: {
          checkout_option: {
            actionField: { step: step, option: checkoutOption }
          }
        }
      };

      window.dataLayer.push(event);
    };

    module.exports = {
      setTagManagerNpm: setTagManagerNpm,
      userLocation: userLocation,
      setUserId: setUserId,
      setMetadata: setMetadata,
      trackPageMeta: trackPageMeta,
      trackEvent: trackEvent,
      trackProductInteractionEvent: trackProductInteractionEvent,
      trackProductPopupEvent: trackProductPopupEvent,
      trackVirtualPath: trackVirtualPath,
      trackPromotionImpression: trackPromotionImpression,
      trackPromotionClick: trackPromotionClick,
      trackProductImpression: trackProductImpression,
      trackProductClick: trackProductClick,
      trackProductDetailView: trackProductDetailView,
      trackPurchase: trackPurchase,
      trackAddToCart: trackAddToCart,
      trackCheckout: trackCheckout,
      trackCheckoutOption: trackCheckoutOption
    };

}));
